import { Injectable } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateTime } from 'luxon';

const FULL_ISO_DATE = /^\d{4}-\d{2}-\d{2}/;

/**
 * LuxonDateAdapter tries `DateTime.fromISO` before the configured parse formats. Luxon's ISO
 * parser accepts fragments ("03" = today 03:00), so a half-typed date already counts as valid
 * and the datepicker rewrites the input mid-typing (#22991). Typed text only takes the ISO route
 * when it starts with a full yyyy-mm-dd date; anything else must match a parse format.
 */
@Injectable()
export class DdLuxonDateAdapter extends LuxonDateAdapter {
  override parse(value: unknown, parseFormat: string | string[]): DateTime | null {
    if (typeof value === 'string' && value.length > 0 && !FULL_ISO_DATE.test(value)) {
      const formats = Array.isArray(parseFormat) ? parseFormat : [parseFormat];
      const matchesFormat = formats.some(format => DateTime.fromFormat(value, format, { locale: this.locale }).isValid);
      if (!matchesFormat) return this.invalid();
    }
    return super.parse(value, parseFormat);
  }
}
